var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFajnoooo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F45E20;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,0C11.2,0,0,11.2,0,25s11.2,25,25,25s25-11.2,25-25S38.8,0,25,0z M25,48C12.3,48,2,37.7,2,25S12.3,2,25,2 s23,10.3,23,23S37.7,48,25,48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.3,19.7c1.2,0,2.3-1,2.3-2.3c0-1.2-1-2.3-2.3-2.3c-1.2,0-2.3,1-2.3,2.3C29,18.7,30,19.7,31.3,19.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.7,19.7c1.2,0,2.3-1,2.3-2.3c0-1.2-1-2.3-2.3-2.3c-1.2,0-2.3,1-2.3,2.3C16.5,18.7,17.5,19.7,18.7,19.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.6,29.3L37.6,29.3l-25.2,0c-0.4,0-0.9,0.2-1.1,0.6c-0.2,0.3-0.2,0.7,0,1.1c2.6,5.3,7.8,8.5,13.6,8.5 s11.1-3.3,13.6-8.5c0.2-0.4,0.2-0.8,0-1.1C38.4,29.5,38,29.3,37.6,29.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFajnoooo);
export default __webpack_public_path__ + "static/media/fajnoooo.642a358ac27b5b42371d2a243f4c6535.svg";
export { ForwardRef as ReactComponent };